module.exports = __webpack_public_path__ + "static/media/logo11.9d143463.png";